import axios from 'axios'
import _get from 'lodash/get'

import { receiveProfile } from '@/store/profile'

import { handleRequestError } from './request'

export const RECEIVE_ACCOUNTANT = 'RECEIVE_ACCOUNTANT'
export const REQUEST_ACCOUNTANT = 'REQUEST_ACCOUNTANT'

export const ASSIGN_ACCOUNTANT = 'ASSIGN_ACCOUNTANT'

export const requestAccountant = (id) => (dispatch) => {
    dispatch({ type: REQUEST_ACCOUNTANT, data: { id } })

    return axios
        .get(`/accountant/${id}`)
        .then((response) => {
            const data = _get(response, ['data'], {})
            dispatch(receiveAccountant({ ...data, fetchSuccessful: true }))
        })
        .catch((error) => {
            if (_get(error, ['response', 'status']) === 404) {
                dispatch(receiveAccountant({ fetchSuccessful: true }))
                return Promise.resolve()
            }

            dispatch(receiveAccountant({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))

            return Promise.reject(error)
        })
}

export const receiveAccountant = (data) => ({ type: RECEIVE_ACCOUNTANT, data })

// @TODO: Should be part of Profile actions
export const assignAccountant = () => (dispatch, getState) => {
    dispatch({ type: ASSIGN_ACCOUNTANT })

    const { profile } = getState()
    const { id: userId } = profile

    return axios
        .put(`/user/${userId}/accountant`)
        .then((response) => {
            const responseData = _get(response, ['data'], {})
            dispatch(receiveProfile(responseData))

            return Promise.resolve(responseData)
        })
        .catch((error) => {
            dispatch(handleRequestError(error))

            return Promise.reject(error)
        })
}
